import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useEffect, useState } from "react";
import { BrowserView, isBrowser } from "react-device-detect";
import Button from "../Misc/Button";
import { Invoice, InvoiceStatus, Subscription } from "../Types";
import "./index.css";

type Props = {
  invoices: Invoice[];
  subscriptions: Subscription[];
  siteId?: number;
}

export default function Invoices({ invoices, subscriptions, siteId }: Props) {
  const [activeSiteId, setActiveSiteId] = useState<number | null>(null);


  useEffect(() => {
    if (siteId) {
      setActiveSiteId(siteId);
    }
  }, [siteId])
  const filtered = activeSiteId === null
    ? invoices
    : invoices.filter(invoice => invoice.siteId === activeSiteId);

  return (
    <div className="invoices-container">
      {subscriptions.length > 1 && (
        <div className="invoice-filter-container">
          <Button isSmaller isPrimary isActive={activeSiteId === null} label="Alla" onClick={() => setActiveSiteId(null)} />
          {subscriptions.map(sub => (
            <Button
              key={sub.id}
              isSmaller
              isPrimary
              isActive={activeSiteId === sub.id}
              label={sub.adress}
              onClick={() => setActiveSiteId(sub.id)}
            />
          ))}
        </div>
      )}
      <table>
        {filtered.map((invoice, index) => (
          <tr key={index} style={{ animationDelay: index * 0.09 + "s" }} className="invoice-row">
            <td className={classNames({
              [invoice.status.toLowerCase()]: true,
              "invoice-status": true,
            })}>{InvoiceStatus[invoice.status]} <span className="invoice-id">({invoice.id})</span></td>
            <td className="invoice-price">{invoice.price} kr</td>
            <Button onClick={() => window.open(invoice.link, '_blank', 'noopener,noreferrer')} label={isBrowser ? "Visa faktura" : <FontAwesomeIcon icon={faEye} />} isActive={false} isPrimary={false} />
          </tr>
        ))}
      </table>
    </div>
  );
}
